"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

exports.__esModule = true;
exports.QueriesObserver = void 0;

var _utils = require("./utils");

var _notifyManager = require("./notifyManager");

var _queryObserver = require("./queryObserver");

var _subscribable = require("./subscribable");

var QueriesObserver = /*#__PURE__*/function (_subscribable$Subscri) {
  _inherits(QueriesObserver, _subscribable$Subscri);

  var _super = _createSuper(QueriesObserver);

  function QueriesObserver(client, queries) {
    var _this;

    _classCallCheck(this, QueriesObserver);

    _this = _super.call(this);
    _this.client = client;
    _this.queries = [];
    _this.result = [];
    _this.observers = [];
    _this.observersMap = {};

    if (queries) {
      _this.setQueries(queries);
    }

    return _this;
  }

  _createClass(QueriesObserver, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      var _this2 = this;

      if (this.listeners.length === 1) {
        this.observers.forEach(function (observer) {
          observer.subscribe(function (result) {
            _this2.onUpdate(observer, result);
          });
        });
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.listeners.length) {
        this.destroy();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners = [];
      this.observers.forEach(function (observer) {
        observer.destroy();
      });
    }
  }, {
    key: "setQueries",
    value: function setQueries(queries, notifyOptions) {
      var _this3 = this;

      this.queries = queries;

      _notifyManager.notifyManager.batch(function () {
        var prevObservers = _this3.observers;

        var newObserverMatches = _this3.findMatchingObservers(_this3.queries); // set options for the new observers to notify of changes


        newObserverMatches.forEach(function (match) {
          return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
        });
        var newObservers = newObserverMatches.map(function (match) {
          return match.observer;
        });
        var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
          return [observer.options.queryHash, observer];
        }));
        var newResult = newObservers.map(function (observer) {
          return observer.getCurrentResult();
        });
        var hasIndexChange = newObservers.some(function (observer, index) {
          return observer !== prevObservers[index];
        });

        if (prevObservers.length === newObservers.length && !hasIndexChange) {
          return;
        }

        _this3.observers = newObservers;
        _this3.observersMap = newObserversMap;
        _this3.result = newResult;

        if (!_this3.hasListeners()) {
          return;
        }

        (0, _utils.difference)(prevObservers, newObservers).forEach(function (observer) {
          observer.destroy();
        });
        (0, _utils.difference)(newObservers, prevObservers).forEach(function (observer) {
          observer.subscribe(function (result) {
            _this3.onUpdate(observer, result);
          });
        });

        _this3.notify();
      });
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return this.result;
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(queries) {
      return this.findMatchingObservers(queries).map(function (match) {
        return match.observer.getOptimisticResult(match.defaultedQueryOptions);
      });
    }
  }, {
    key: "findMatchingObservers",
    value: function findMatchingObservers(queries) {
      var _this4 = this;

      var prevObservers = this.observers;
      var defaultedQueryOptions = queries.map(function (options) {
        return _this4.client.defaultQueryOptions(options);
      });
      var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
        var match = prevObservers.find(function (observer) {
          return observer.options.queryHash === defaultedOptions.queryHash;
        });

        if (match != null) {
          return [{
            defaultedQueryOptions: defaultedOptions,
            observer: match
          }];
        }

        return [];
      });
      var matchedQueryHashes = matchingObservers.map(function (match) {
        return match.defaultedQueryOptions.queryHash;
      });
      var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
        return !matchedQueryHashes.includes(defaultedOptions.queryHash);
      });
      var unmatchedObservers = prevObservers.filter(function (prevObserver) {
        return !matchingObservers.some(function (match) {
          return match.observer === prevObserver;
        });
      });

      var getObserver = function getObserver(options) {
        var defaultedOptions = _this4.client.defaultQueryOptions(options);

        var currentObserver = _this4.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new _queryObserver.QueryObserver(_this4.client, defaultedOptions);
      };

      var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
        if (options.keepPreviousData) {
          // return previous data from one of the observers that no longer match
          var previouslyUsedObserver = unmatchedObservers[index];

          if (previouslyUsedObserver !== undefined) {
            return {
              defaultedQueryOptions: options,
              observer: previouslyUsedObserver
            };
          }
        }

        return {
          defaultedQueryOptions: options,
          observer: getObserver(options)
        };
      });

      var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
        return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
      };

      return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(observer, result) {
      var index = this.observers.indexOf(observer);

      if (index !== -1) {
        this.result = (0, _utils.replaceAt)(this.result, index, result);
        this.notify();
      }
    }
  }, {
    key: "notify",
    value: function notify() {
      var _this5 = this;

      _notifyManager.notifyManager.batch(function () {
        _this5.listeners.forEach(function (listener) {
          listener(_this5.result);
        });
      });
    }
  }]);

  return QueriesObserver;
}(_subscribable.Subscribable);

exports.QueriesObserver = QueriesObserver;